enum EmailAppointmentFlow {
  INFO = 'INFO',
  CONFIRMATION = 'CONFIRMATION',
  ZOOM_LINK = 'ZOOM_LINK',
}

export default EmailAppointmentFlow
